const questions = [
    {
      category: 'General Info',
      question: 'Please enter your email address: ',
      type: 'text',
      name: 'email_address',
      meta: true
    },
    {
      category: 'General Info',
      question: '1) What ages are your children? (Check as many as apply)',
      type: 'checkbox',
      name: 'child_ages',
      options: [
        {answer: '0–5', value: 'a'},
        {answer: '5–10', value: 'b'},
        {answer: '11–15', value: 'c'},
        {answer: '15+', value: 'd'}
      ],
      points: null
    },
    {
      category: 'General Info',
      question: '2) What country do you currently live in?',
      type: 'text',
      name: 'country'
    },
    {
      category: 'General Info',
      question: '3) What kind of school do your children currently attend? (Check as many as apply)',
      type: 'checkbox',
      name: 'school_type',
      options: [
        'Public school',
        'Private school',
        'International school',
        'Boarding school',
        'Alternative education / homeschool',
        'My child is an adult already / not in school',
        'Other'
      ]
    },
    {
      category: 'Digital Wellbeing Environment at Home',
      question: '4) What is the average number of screentime hours your child has on a weekday (not including schoolwork)?',
      type: 'radio',
      name: 'screentime',
      options: [
        {answer: '0–2.5 hrs/day', value: 'a'},
        {answer: '2.5–4 hrs', value: 'b'},
        {answer: '4–6 hrs', value: 'c'},
        {answer: '6+ hrs', value: 'd'}
       ],
       scoring: (answers) => {
        const child_ages = answers['child_ages'] || []; // answers from Q1
        const screentime = answers['screentime']; // selected option for Q4

        if (screentime === 'a' && child_ages.includes('a')) {
return 1;
}
        if (screentime === 'b' && !child_ages.includes('a')) {
return 2;
}
        return 0;
      }
    },
    {
      category: 'Digital Wellbeing Environment at Home',
      question: '5) How familiar are you with the digital platforms and apps your child uses most often? Select one only.',
      type: 'likert',
      name: 'app_familiarity',
      options: [
        {answer: 'I don’t know most of them', points: 0},
        {answer: 'I know some of them but not all', points: 1},
        {answer: 'I know them all', points: 2}
      ]
    },
    {
      category: 'Digital Wellbeing Environment at Home',
      question: '6) How confident are you in your ability to choose healthy media content and screentime activities (videos, games, etc) for your child? Select one only.',
      type: 'likert',
      name: 'confident_ability',
      options: [
        {answer: 'Not confident at all', points: 0},
        {answer: 'Somewhat confident', points: 1},
        {answer: 'Very confident', points: 2}
      ]
    },
    {
      category: 'Digital Wellbeing Environment at Home',
      question: '7) How confident do you feel in guiding your child to balance screen time with other activities? Select one only.',
      type: 'likert',
      name: 'confident_guide',
      options: [
        {answer: 'Not confident at all', points: 0},
        {answer: 'Somewhat confident', points: 1} ,
        {answer: 'Very confident', points: 2}
      ]
    },
    {
      category: 'Digital Wellbeing Environment at Home',
      question: '8) How often do you talk to your children to learn about what they’re thinking and feeling about what they see online? Select one only.',
      type: 'likert',
      name: 'talk_online_activity',
      options: [
        {answer: 'Almost never', points: 0},
        {answer: 'Sometimes', points: 1},
        {answer: 'Often', points: 2}
       ]
    },
    {
      category: 'Digital Wellbeing Environment at Home',
      question: '9) How often do you talk to your children to learn about what they’re doing online? Select one only.',
      type: 'likert',
      name: 'talk_learning',
      options: [
        {answer: 'Almost never', points: 0},
        {answer: 'Sometimes', points: 1},
        {answer: 'Often', points: 2}
       ]
    },
    {
      category: 'Digital Wellbeing Environment at Home',
      question: '10) How often does your child have their meal times in front of a screen? Select one only.',
      type: 'likert',
      name: 'meal_screen',
      options: [
        {answer: 'They almost never eat with a screen', points: 4},
        {answer: 'More than 5 times / week they eat with a screen', points: 2},
        {answer: 'At least 1 meal per day they have a screen', points: 0} ]
    },
    {
      category: 'Digital Wellbeing Environment at Home',
      question: '11) Do you have parental controls in place for your child on all the devices (iPad, phone, laptop) and online websites / apps (Netflix, Roblox) they use? Select one only.',
      type: 'likert',
      name: 'parental_controls',
      options: [
        {answer: 'I don’t know about parental controls at all yet', points: 0},
        {answer: 'Not really but I want to know how', points: 1},
        {answer: 'On some but not all devices', points: 2},
        {answer: 'Yes, on all our devices', points: 3}
      ]
    },
    {
      category: 'Digital Wellbeing Environment at Home',
      question: '12) Do you have a plan or idea yet of what age you will begin preparing your child for their first phone? Select one only.',
      type: 'likert',
      name: 'prep_phone',
      options: [
        {answer: 'I haven’t really thought about it yet', value: 'a'},
        {answer: 'I have an idea but I want to learn more', value: 'b'},
        {answer: 'Yes, I have an idea and have discussed it with my partner', value: 'c'}],
        scoring: (answers) => {
          const child_ages = answers['child_ages'] || []; // answers from Q1
          const prep_phone = answers['prep_phone']; // selected option for Q12

          if (prep_phone === 'a' && !child_ages.includes('a')) {
return 0;
}
          if (prep_phone === 'b' && !child_ages.includes('a')) {
return 1;
}
          if (prep_phone === 'c') {
return 2;
}
          return 0;
        }
    },
    {
      category: 'Family Communication on Digital Wellbeing and AI',
      question: '13) How confident are you that your kids know how to use digital devices safely? Select one only.',
      type: 'likert',
      name: 'digital_safety',
      options: [
        {answer: 'Not confident at all', points: 0},
        {answer: 'Not confident', points: 1},
        {answer: 'Somewhat confident', points: 2},
        {answer: 'Very confident', points: 3}
       ]
    },
    {
      category: 'Family Communication on Digital Wellbeing and AI',
      question: '14) How confident are you that your child’s close friends know how to use digital devices safely? Select one only.',
      type: 'likert',
      name: 'friends_safety',
      options: [
        {answer: 'Not confident at all', value: 'a'},
        {answer: 'Not confident', value: 'b'},
        {answer: 'Somewhat confident', value: 'c'},
        {answer: 'Very confident', value: 'd'}
       ],
       scoring: (answers) => {
         const friends_safety = answers['friends_safety'];


         if (friends_safety === 'a') {
return 0;
}
         if (friends_safety === 'b') {
return 1;
}
         if (friends_safety === 'c') {
return 2;
}
         if (friends_safety === 'd') {
return 3;
}
       }
    },
    {
      category: 'Family Communication on Digital Wellbeing and AI',
      question: '15) How much does your child use AI, to your knowledge? Select one only.',
      type: 'likert',
      name: 'ai_usage',
      options: [
        {answer: 'They don’t use it at all', value: 'a'},
        {answer: 'I’m not sure', value: 'b'},
        {answer: 'Not very frequently', value: 'c'},
        {answer: 'Somewhat frequently (a few times per week)', value: 'd'},
        {answer: 'Frequently', value: 'e'}
      ],
        scoring: (answers) => {
          const friends_safety = answers['friends_safety'] || []; // answers from Q14
          const ai_usage = answers['ai_usage']; // selected option for Q15


          if (ai_usage === 'a') {
return 1;
}
          if (ai_usage === 'b') {
return 0;
}
          if (ai_usage === 'c')  {
return 2;
}
          if (ai_usage === 'd' && (friends_safety === 'a' || friends_safety === 'b')) {
return 1;
}
          if (ai_usage === 'e' && (friends_safety === 'a' || friends_safety === 'b')) {
return 0;
}
          return 0;
        }

    },
    {
      category: 'Family Communication on Digital Wellbeing and AI',
      question: '16) If your child had something bad happen to them online, how likely do you think they would be to come to you first to ask for help? Select one only.',
      type: 'likert',
      name: 'parent_help',
      options: [
        {answer: 'I don’t know', points: 0},
        {answer: 'They would go to their friends, siblings or another trusted adult for help', points: 1},
        {answer: 'They would definitely come to me first', points: 2}
       ]
    },
    {
      category: 'Family Communication on Digital Wellbeing and AI',
      question: '17) Do you use access to wifi or their devices as a disciplinary tool (do you take away their wifi or phones when they misbehave)? Select one only.',
      type: 'likert',
      name: 'access_discipline',
      options: [
        {answer: 'No, not really', points: 2},
        {answer: 'Sometimes', points: 1},
        {answer: 'Yes, often', points: 0}
       ]
    },
    {
      category: 'Parental Resourcefulness and Self-Efficacy',
      question: '18) How comfortable are you discussing these topics with your child? Select only one for each question.',
      type: 'grouped_likert',
      name: 'comfortable_discussing',
      subQuestions: [
        { label: 'Social media and body image', name: 'comfortable_social_media' },
        { label: 'Mental health and emotional well-being', name: 'comfortable_mental_health' },
        { label: 'Staying safe online', name: 'comfortable_safety' },
        { label: 'Cyberbullying', name: 'comfortable_cyberbullying' },
        { label: 'Gaming / gaming addiction', name: 'comfortable_gaming' },
        { label: 'AI assistants', name: 'comfortable_ai' },
        { label: 'Deepfakes / Misinformation', name: 'comfortable_deepfakes' },
      ],
      options: [
        {answer: 'Really uncomfortable', points: 0},
        {answer: 'Not comfortable', points: 0},
        {answer: 'Somewhat comfortable', points: 1},
        {answer: 'Very comfortable', points: 4}
      ]
    },
    {
      category: 'Parental Resourcefulness and Self-Efficacy',
      question: '19) Do you feel prepared to answer questions from your child about things they might see online that make them feel scared or confused (like natural disasters, war/violence, sexualised content, etc.)? Select one only.',
      type: 'likert',
      name: 'danger_prepared',
      options: [
        {answer: 'I haven’t thought about this and don’t know', points: 0},
        {answer: 'I have some idea but don’t know how to have this conversation', points: 2},
        {answer: 'Yes, I know how I will prepare my child', points: 3}
       ]
    },
    {
      category: 'Parental Resourcefulness and Self-Efficacy',
      question: '20) How confident are you that you are role modeling the following behaviors for your child?',
      type: 'grouped_likert',
      name: 'role_model',
      subQuestions: [
        { label: 'Balancing screen time with other activities', name: 'rolemodel_screen_balance' },
        { label: 'Not eating in front of screens', name: 'rolemodel_no_screen_meals' },
        { label: 'Spending quality time in-person with others without being distracted by your phone / device', name: 'rolemodel_inperson_time' },
        { label: 'Not using technology right when you wake up and not using it right before bedtime', name: 'rolemodel_no_morning_nighttech' },
        { label: 'How to stay safe online and not overshare your personal info or photos with others', name: 'rolemodel_online_safety' },
        { label: 'How to speak respectfully to others online and observe digital etiquette', name: 'rolemodel_respect_online' },
        { label: 'How to take breaks from your phone or technology when they affect your mood or mental health', name: 'rolemodel_take_breaks' },
        { label: 'How to use AI responsibly and effectively', name: 'rolemodel_ai_use' }
      ],
      options: [
        {answer: 'Really not confident', points: 0},
        {answer: 'Not confident', points: 0},
        {answer: 'Somewhat confident', points: 2},
        {answer: 'Very confident', points: 4}
      ]
    },
    {
      category: 'Parental Resourcefulness and Self-Efficacy',
      question: '21) What are your biggest concerns about digital literacy and AI education for your family right now (check as many as apply) ',
      type: 'checkbox',
      name: 'biggest_concerns',
      options: ['Addressing specific digital problems my child already has (like gaming addiction, social media addiction, poor time management issues)',
        'Keeping my kids safe online from scams and online predators',
        'Teaching my kids to manage cyberbullying',
        'Teaching my kids how to use their critical thinking online and avoid misinformation and deepfakes',
        'Giving my kids a foundation for digital wellbeing and good mental health when it comes to their digital lives',
        'Maintaining strong family values and relationships without digital interruptions',
        'Avoiding addictive digital behavior (gaming addiction, online shopping addiction, social media addiction)',
        'Teaching my kids to use AI for their life-long success in school and work',
        'Other (fill in)']
    },
    {
      category: 'School-Parent Communication',
      question: '22) Have you received any emails or newsletters about AI and digital wellbeing from your child’s school? Select one only.',
      type: 'likert',
      name: 'school_communication',
      options: [
        {answer: 'None that I can remember', points: 0},
        {answer: 'Maybe, I’m not sure', points: 1},
        {answer: 'Yes, several that I can remember', points: 2},
        {answer: 'Not applicable', points: 1}
       ]
    },
    {
      category: 'School-Parent Communication',
      question: '23) Does your school offer parent trainings, talks or workshops about any of these digital parenting topics? Select one only.',
      type: 'likert',
      name: 'parent_training',
      options: [
        {answer: 'No, not at all', points: 0},
        {answer: 'Yes, but not enough', points: 1},
        {answer: 'Yes, a lot', points: 2},
        {answer: 'Not applicable', points: 1}
       ]
    },
    {
      category: 'School-Parent Communication',
      question: "24) Do you think it is important for your child's school to improve its digital literacy or digital wellbeing practices?",
      type: 'likert',
      name: 'school_prep',
      options: [
        {answer: 'Yes, very important', points: 3},
        {answer: 'Somewhat important', points: 2},
        {answer: 'Not very important', points: 1},
        {answer: 'Not important at all', points: 0}
      ]
    },
    {
      category: 'School-Parent Communication',
      question: '25) Have there been any incidents at your child’s school related to cyberbullying, gaming addiction or improper use of technology? Select one only.',
      type: 'likert',
      name: 'cyberbullying_incidents',
      options: [
        {answer: 'No', points: 2},
        {answer: 'Yes, but only a few I know of', points: 1},
        {answer: 'Yes, several that I know of recently', points: 0}
       ]
    },
    {
      category: 'School-Parent Communication',
      question: '26) If you had a question about digital parenting, AI education, social media, cyberbullying or another similar topic, where would you most likely go for answers (rank in order of which ones you would go to first): ',
      type: 'ranking',
      name: 'parenting_resources',
      options: [
        'Google',
        'AI',
        'My child’s school',
        'My child’s doctor / therapist',
        'My spouse, family, or other parents I trust',
        'Social media parenting channels',
        'Other'
      ]
    },
    {
      category: 'School-Parent Communication',
      question: '27) I would like to receive more of this information or training from my child’s school (Check as many as apply): ',
      type: 'checkbox',
      name: 'more_info',
      options: ['How to handle specific digital behavior problems at home (like gaming addiction, social media addiction, poor time management issues)',
        'How to keep my kids safe online from scams and online predators',
        'How to teach my kids to manage cyberbullying',
        'How to teach my kids how to use their critical thinking online and avoid misinformation and deepfakes',
        'How to give my kids a foundation for digital wellbeing and good mental health when it comes to their digital lives',
        'How to maintain strong family values and relationships without digital interruptions',
        'How to teach my kids to use AI for their life-long success in school and work',
        'Other (fill in)'
      ]
    },
    {
      category: 'School-Parent Communication',
      question: '28) I prefer to get information or trainings from my school by (Check as many as apply): ',
      type: 'checkbox',
      name: 'info_trainings',
      options: ['Attending in-person workshops or coffee talks', 'Attending virtual events', 'Newsletters with linked parenting resources and tips']
    },
    {
      category: 'School-Parent Communication',
      question: '29) If your school offered a private AI Tech Coach to you to ask all your digital wellbeing questions to at home, how likely would you be to use it? Select one only.',
      type: 'likert',
      name: 'ai_coach',
      options: ['Definitely wouldn’t use it', 'Not likely', 'Somewhat likely', 'Very likely']
    },
    {
      category: 'School-Parent Communication',
      question: '30) If you answered “Not likely or definitely wouldn’t use it” what is your main concern with it? If you don\'t have any concerns, please type \'None\' (open short text response)',
      type: 'text',
      name: 'main_concern'
    }
  ];

  export default questions;
